var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnknownFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m51 12v43c0 2.209-1.791 4-4 4h-34c-2.209 0-4-1.791-4-4v-50c0-2.209 1.791-4 4-4h27z",
    fill: "#e8ecef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m51 12h-10c-.55 0-1-.45-1-1v-10z",
    fill: "#c7d0dd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#69adfe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.998 25.795c.1 6.041-4.253 11.074-9.998 12.034v3.17h-4v-5.284c0-.948.768-1.716 1.716-1.716 4.256 0 7.979-3.203 8.265-7.45.314-4.658-3.389-8.55-7.981-8.55-3.878 0-7.121 2.775-7.848 6.443-.181.915-1.013 1.557-1.946 1.557-1.248 0-2.218-1.136-1.974-2.36 1.127-5.657 6.228-9.876 12.272-9.629 6.266.256 11.391 5.514 11.495 11.785z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 48,
    r: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownFile);
export default __webpack_public_path__ + "static/media/unknown-file.70eb579661d1d57be1c71735f4c73611.svg";
export { ForwardRef as ReactComponent };